import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import ResourceCard from 'common/components/ResourceCard';

export default function bind() {
  const $resources = $('.resource.card');
  $resources.each((index, element) => {
    const $element = $(element);

    const name = $element.attr('data-name');
    const title = $element.attr('data-title');
    const value = $element.attr('data-value');
    const mini = $element.attr('data-mini');
    const thumbnail = $element.attr('data-thumbnail');

    // Building resource
    const resource = {
      id: value,
      mini,
      web: thumbnail,
    };

    ReactDOM.render(
      <ResourceCard name={name} title={title} resource={resource} />,
      element
    );
  });
}



// WEBPACK FOOTER //
// ./src/plugins/resources.js